import React, { useMemo } from 'react'
import { Box } from '@mui/material'
import { Item } from '../../../interfaces/Generic/State'
import { ItemRow } from './ItemRow'

interface ItemListProps {
  items: Item[]
  click: (item: string, batchId?: number) => void
  styleModeQuality?: boolean
}

export const ItemList = ({ items, click, styleModeQuality }: ItemListProps) => {
  const sortedItems = useMemo(() => {
    if (!items) {
      return []
    }
    // Create a shallow copy to avoid mutating the original array.
    // The sort logic is simplified to put items with withExcess=true first.
    return [...items].sort((a, b) => {
      if (a.withExcess === b.withExcess) {
        return 0
      }
      return a.withExcess ? -1 : 1
    })
  }, [items])

  if (items === undefined) {
    return <div />
  }

  return (
    <Box
      sx={(theme) => ({
        ml: '5px',
        textAlign: 'center',
        borderRadius: '5px',
        height: '100%',
        overflowX: 'hidden',
        overflowY: 'scroll',
        width: '95%',
        background: styleModeQuality ? '#ffd39e' : 'white',
        border: '0.5px solid #004BB1',
        '&::-webkit-scrollbar': {
          width: '10px',
          backgroundColor: '#F5F5F5'
        },
        '&::-webkit-scrollbar-track': {
          boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)',
          backgroundColor: '#F5F5F5',
          borderRadius: '5px'
        },
        '&::-webkit-scrollbar-thumb': {
          borderRadius: '5px',
          backgroundImage:
            '-webkit-gradient(linear,left bottom,left top,color-stop(0.44, rgb(122,153,217)),color-stop(0.72, rgb(73,125,189)),color-stop(0.86, rgb(28,58,148)));'
        },
        '& td': {
          border: '1px solid #000'
        },
        '& tr td:last-child': {
          width: '1%',
          whiteSpace: 'nowrap'
        }
      })}
    >
      <table style={{ width: '100%' }}>
        <tbody>
          {sortedItems.map((item) => (
            <ItemRow
              key={`${item.name}-${item.batchId || 'no-batch'}`}
              item={item}
              onRemove={click}
            />
          ))}
        </tbody>
      </table>
    </Box>
  )
}
